import { GroupTravelStaticAlerts } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/GroupTravelStaticAlerts";
import { LastVisitedStation } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/LastVisitedStation";
import { TrainDetailsButton } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/TrainDetailsButton";
import { TrainEventBadges } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/TrainEventBadges";
import {
  AltTransIncidentArrivalStatus,
  AltTransIncidentTrain,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";
import { CallButton } from "shared/components/buttons/CallButton";
import { Box, Flex, HStack, Text } from "shared/components/Spor";

type ExpandableBodyProps = {
  actionableTrain: AltTransIncidentTrain;
};

export const ExpandableBodyContent: FC<ExpandableBodyProps> = ({
  actionableTrain,
}) => {
  const hasPassed =
    actionableTrain.incidentArrival.status ===
    AltTransIncidentArrivalStatus.DEPARTED_INCIDENT;

  return (
    <>
      <Box color={hasPassed ? "semantics.colorTextTertiary" : undefined}>
        <Text variant="sm" fontWeight="bold">
          Sist passert
        </Text>
        <LastVisitedStation trainRoute={actionableTrain.trainRoute} />
      </Box>

      <Box color={hasPassed ? "semantics.colorTextTertiary" : undefined}>
        <Text variant="sm" fontWeight="bold" mb="1">
          Toghendelser
        </Text>
        <TrainEventBadges events={actionableTrain.events} />
      </Box>

      <Box color={hasPassed ? "semantics.colorTextTertiary" : undefined}>
        <Text variant="sm" fontWeight="bold">
          Kontakt
        </Text>
        <HStack gap="1" mt="1">
          {actionableTrain.trainStaffOnDuty.map((staffOnDuty) => (
            <CallButton
              key={staffOnDuty.functionalTelephoneNumber + staffOnDuty.function}
              label={staffOnDuty.function}
              phoneNumber={staffOnDuty.functionalTelephoneNumber}
              size="xs"
            />
          ))}
        </HStack>
      </Box>

      <div>{/* This box intentionally left blank :) */}</div>
      <Box
        gridColumn="1 / -1"
        color={hasPassed ? "semantics.colorTextTertiary" : undefined}
      >
        <GroupTravelStaticAlerts
          events={actionableTrain.events}
          trainId={actionableTrain.id}
        />
      </Box>

      <Flex
        gridColumn="1 / -1"
        justifyContent="flex-end"
        color={hasPassed ? "semantics.colorTextTertiary" : undefined}
      >
        <TrainDetailsButton altTransPlanningTrainId={actionableTrain.id} />
      </Flex>
    </>
  );
};
